import { createSelector } from "@reduxjs/toolkit";

import { getSlotPlaceholderIdSelector, nodeSlotIdSelector } from "@skilitics/nautilus-core-designer-data";

import { getDesignerNodeByIdSelector, useNautilusSelector } from "../state/index.ts";
import type { DesignerNode } from "../types/index.ts";

const placeholderForNodeIdSelector = createSelector(
  nodeSlotIdSelector,
  getSlotPlaceholderIdSelector,
  getDesignerNodeByIdSelector,
  (slotId, getPlaceholderId, getDesignerNode): DesignerNode | undefined => {
    if (!slotId) return;
    const placeholderId = getPlaceholderId(slotId);
    if (!placeholderId) return;
    return getDesignerNode(placeholderId);
  },
);

export const usePlaceholderFor = (nodeId: number) =>
  useNautilusSelector((state) => placeholderForNodeIdSelector(state, { nodeId }));
